import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useFetchEventsCodeOptions = () => {
  const response = useQuery({
    queryKey: ['referralEventsCodeOptions'],
    queryFn: () => api.referral.fetchCatalog(),
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить список кодов событий',
      type: 'error',
    })
  }

  return response
}
